export const TEMPLATE_EDIT_SESSION_GAP_MS = 10 * 60 * 1000

export const TEMPLATE_SESSION_TYPE = 'TEMPLATE_SESSION'

export const ATTENDEE_SESSION_TYPE = 'ATTENDEE_SESSION'

export const ATTENDEE_EVENT_TYPES = ['ADD_ATTENDEE', 'UPDATE_ATTENDEE', 'DELETE_ATTENDEE']

const SESSION_EVENT_TYPES: Record<string, string[]> = {
  [TEMPLATE_SESSION_TYPE]: [
    'ADD_TEMPLATE_ITEM',
    'REMOVE_TEMPLATE_ITEM',
    'MOVE_TEMPLATE_ITEM',
    'EDIT_TEMPLATE_ITEM',
    'ATTACH_TEMPLATE_DOCUMENT',
    'DETACH_TEMPLATE_DOCUMENT',
  ],
  [ATTENDEE_SESSION_TYPE]: ATTENDEE_EVENT_TYPES,
}

const HIDDEN_EVENT_TYPES = ['VIEW_MEETING']

export type TimelineEvent = {
  type: string
  timestamp: Date | string
  userName: string | null
  metadata: any | null
}

export type TimelineGroup = {
  type: string
  userName: string | null
  firstTimestamp: Date
  lastTimestamp: Date
  events: TimelineEvent[]
  detailEvents: TimelineEvent[]
}

function timeOf(event: TimelineEvent): number {
  return new Date(event.timestamp).getTime()
}

function sessionTypeOf(event: TimelineEvent): string | null {
  const entry = Object.entries(SESSION_EVENT_TYPES).find(([, eventTypes]) => eventTypes.includes(event.type))
  return entry?.[0] ?? null
}

function continuesSession(group: TimelineGroup, event: TimelineEvent, gapMs: number): boolean {
  return sessionTypeOf(event) === group.type && group.userName === event.userName && timeOf(event) - group.lastTimestamp.getTime() <= gapMs
}

function startGroup(event: TimelineEvent): TimelineGroup {
  const sessionType = sessionTypeOf(event)
  return {
    type: sessionType ?? event.type,
    userName: event.userName,
    firstTimestamp: new Date(timeOf(event)),
    lastTimestamp: new Date(timeOf(event)),
    events: [event],
    detailEvents: sessionType === null ? [] : [event],
  }
}

function absorb(group: TimelineGroup, event: TimelineEvent) {
  group.events.push(event)
  group.detailEvents.push(event)
  group.lastTimestamp = new Date(timeOf(event))
}

export function groupTimelineEvents(events: TimelineEvent[], gapMs: number = TEMPLATE_EDIT_SESSION_GAP_MS): TimelineGroup[] {
  return events
    .filter((event) => !HIDDEN_EVENT_TYPES.includes(event.type))
    .sort((first, second) => timeOf(first) - timeOf(second))
    .reduce<TimelineGroup[]>((groups, event) => {
      const openGroup = groups.at(-1)
      if (openGroup === undefined || !continuesSession(openGroup, event, gapMs)) {
        return [...groups, startGroup(event)]
      }

      absorb(openGroup, event)
      return groups
    }, [])
}
